import React from "react"
import moment from "moment"

interface MenuNavigationProps {
  availableDates: Date[],
  currentDate: Date,
  onChange: Function
}

class MenuNavigationInner extends React.Component<MenuNavigationProps> {
  constructor(props: MenuNavigationProps) {
    super(props)

    this.nextWeek = this.nextWeek.bind(this)
    this.previousWeek = this.previousWeek.bind(this)
    this.changeWeek = this.changeWeek.bind(this)
    this.renderPreviousWeek = this.renderPreviousWeek.bind(this)
    this.renderNextWeek = this.renderNextWeek.bind(this)
  }

  nextWeek() {
    this.changeWeek(1)
  }

  previousWeek() {
    this.changeWeek(-1)
  }

  changeWeek(change) {
    const { currentDate, onChange } = this.props
    const newDate = moment.utc(currentDate).add(change, "week").toDate()
    onChange(newDate)
  }

  renderPreviousWeek() {
    const { currentDate, availableDates } = this.props
    const firstDate = availableDates[0]
    const newDate = moment.utc(currentDate).add(-1, "week")

    if (newDate.isSameOrAfter(firstDate)) {
      return (
        <button
          title="Previous Week."
          className="w-10 h-10 inline-block border rounded-full text-lg mr-2 flex justify-center items-center"
          onClick={this.previousWeek}
        >
          <i className="fas fa-caret-left" />
        </button>
      )
    }
  }

  renderNextWeek() {
    const { currentDate, availableDates } = this.props
    const firstDate = availableDates[availableDates.length - 1]
    const newDate = moment.utc(currentDate).add(1, "week")

    if (newDate.isSameOrBefore(firstDate)) {
      return (
        <button
          title="Previous Week."
          className="w-10 h-10 inline-block border rounded-full text-lg mr-2 flex justify-center items-center"
          onClick={this.nextWeek}
        >
          <i className="fas fa-caret-right" />
        </button>
      )
    }
  }

  render() {
    const { currentDate } = this.props
    const date = moment.utc(currentDate)

    if (currentDate) {
      return (
        <div className="text-xl leading-10 mb-8">
          Menu highlights for the week of
          <div className="flex justify-center">
            <strong className="block text-[42px] pr-4">
              {date.format("MMMM Do, YYYY")}
            </strong>
            {this.renderPreviousWeek()}
            {this.renderNextWeek()}
          </div>
        </div>
      )
    }
    return (<span />)
  }
}

export function MenuNavigation(props: MenuNavigationProps) {
  return <MenuNavigationInner {...props} />
}
